import { getUserUrl } from '@domain/routes/urls';
import { InternalLink } from '../Clickables/InternalLink/InternalLink';

interface IProps {
  userTag: string;
}

const constructUserParameter = (userTag: string): string => {
  return userTag.trim().substring(1);
};

export const TagUser = ({ userTag }: IProps) => {
  return <InternalLink to={getUserUrl(constructUserParameter(userTag))}>{userTag}</InternalLink>;
};
